import React from "react";
import styled, { ThemeProvider } from "styled-components";
import FileUploadPR from "../../PrimeReact/FileUploadPR";
import theme from "../../../utils/themes/SFUCentralTheme";

const StyledUpload = styled(FileUploadPR)`
  display: ${(props) => props.theme.fileUpload.display};
  padding: ${(props) => props.theme.fileUpload.padding};
  font-family: ${(props) => props.theme.fileUpload.fontFamily};
  font-weight: ${(props) => props.theme.fileUpload.fontWeight};
  font-size: ${(props) => props.theme.fileUpload.fontSize};
  color: ${(props) => props.theme.fileUpload.color};
  text-transform: ${(props) => props.theme.fileUpload.textTransform};
  text-decoration: ${(props) => props.theme.fileUpload.textDecoration};
  vertical-align: ${(props) => props.theme.fileUpload.verticalAlign};
  background-color: ${(props) => props.theme.fileUpload.backgroundColor};
  border: ${(props) => props.theme.fileUpload.border};
  border-radius: ${(props) => props.theme.fileUpload.borderRadius};
  cursor: ${(props) => props.theme.fileUpload.cursor};

  &:hover {
    color: ${(props) => props.theme.fileUpload.hover.color};
    background-color: ${(props) =>
      props.theme.fileUpload.hover.backgroundColor};
    border: ${(props) => props.theme.fileUpload.hover.border};
  }

  & .p-button {
    padding: ${(props) => props.theme.fileUpload.button.padding};
    background: ${(props) => props.theme.fileUpload.button.background};
    border: ${(props) => props.theme.fileUpload.button.border};
    border-radius: ${(props) => props.theme.fileUpload.button.borderRadius};
  }

  &:hover .p-button {
    color: ${(props) => props.theme.fileUpload.button.hover.color};
  }
`;

export default function FileUpload({
  children,
  mode,
  name,
  url,
  accept,
  maxFileSize,
  onBeforeUpload,
  onBeforeSend,
  onUpload,
  auto,
  chooseLabel,
  className,
  disabled,
  onError,
}) {
  return (
    <ThemeProvider theme={theme}>
      <StyledUpload
        mode={mode}
        name={name}
        url={url}
        accept={accept}
        maxFileSize={maxFileSize}
        onBeforeUpload={onBeforeUpload}
        onBeforeSend={onBeforeSend}
        onUpload={onUpload}
        auto={auto}
        chooseLabel={chooseLabel}
        className={className}
        disabled={disabled}
        onError={onError}
      >
        {children}
      </StyledUpload>
    </ThemeProvider>
  );
}
